import React from 'react';
import HrFeatureAccess from '.';

const Index = () => {
	return <HrFeatureAccess />;
};
export default Index;
